import {useContext} from "react";
import {observer} from "mobx-react";
import ClickableLink from "../../../utilities/ClickableLink";
import {ErrorBoundary} from "../../../utilities/ErrorBoundary";
import FontAwesome from "../../../utilities/FontAwesome";
import MobileNav, {navigationContent, userMenuContent} from './MobileNav';
import {StoreContext} from "../../../../stores/StoreLoader";
import styles from '../../styles/MobileNavFooter.module.scss';
import {useMainUrl} from "../../../../hooks/useMainUrl";

export const MobileNavFooter = observer((props: {
    showSchoolFeed: boolean,
}) => {
    const {interfaceStore, i18nStore, organizationStore, userStore} = useContext(StoreContext);
    const accountIdentifier = 'account-id';
    const navigationIdentifier = 'nav-id';
    const schoolFeedIdentifier = 'schoolfeed-id';

    const mainUrl = useMainUrl();

    const menuItems = [<li className={styles.listItem} key={'Home'}>
        <ClickableLink href={mainUrl}
                       title={'Home'}
                       className={styles.menuButton}
        >
            <span>
                <FontAwesome prefix={'fas'} name={'fa-home fa-2x'}/>
                <span className={styles.menuItemName}>{'Home'}</span>
            </span>
        </ClickableLink>
    </li>];

    menuItems.push(<li className={styles.listItem} key={accountIdentifier}>
        <button aria-label={'Open Account Menu'}
                onClick={() => handleClick(accountIdentifier)}
                className={styles.menuButton}
        >
            <span>
                <FontAwesome name={'fa-user fa-2x'} prefix={'fas'}/>
                <span className={styles.menuItemName}>{'Account'}</span>
            </span>
        </button>
    </li>);

    if (props.showSchoolFeed) {
        menuItems.push(<li className={styles.listItem} key={schoolFeedIdentifier}>
            <button aria-label={'Open SchoolFeed'}
                    onClick={() => handleClick(schoolFeedIdentifier)}
                    className={styles.menuButton}
            >
                <span>
                    <FontAwesome prefix={'fab'} name={'fa-stripe-s fa-2x'}/>
                    <span className={styles.menuItemName}>{'SchoolFeed'}</span>
                </span>
            </button>
        </li>);
    }

    menuItems.push(<li className={styles.listItem} key={navigationIdentifier}>
        <button
            aria-label={'Open Navigation Menu'}
            onClick={() => handleClick(navigationIdentifier)}
            className={styles.menuButton}
        >
            <span>
                <FontAwesome name={'fa-bars fa-2x'} prefix={'fas'}/>
                <span className={styles.menuItemName}>{'Menu'}</span>
            </span>
        </button>
    </li>);

    function handleClick(eventId) {
        // on click, toggle clicked one and close the others.
        switch (eventId) {
            case accountIdentifier:
                if (interfaceStore.isMobileNavMenuOpen) interfaceStore.toggleMobileNavMenu();
                if (interfaceStore.schoolFeedWidgetOpen) interfaceStore.toggleSchoolFeedWidgetOpen();
                interfaceStore.toggleMobileAccountMenu();
                break;

            case navigationIdentifier:
                if (interfaceStore.isMobileAccountMenuOpen) interfaceStore.toggleMobileAccountMenu();
                if (interfaceStore.schoolFeedWidgetOpen) interfaceStore.toggleSchoolFeedWidgetOpen();
                interfaceStore.toggleMobileNavMenu();
                break;

            case schoolFeedIdentifier:
                if (interfaceStore.isMobileAccountMenuOpen) interfaceStore.toggleMobileAccountMenu();
                if (interfaceStore.isMobileNavMenuOpen) interfaceStore.toggleMobileNavMenu();
                interfaceStore.toggleSchoolFeedWidgetOpen();
                break;
        }
    }

    return <ErrorBoundary>
        <div className={styles.container}>
            <ul className={styles.unorderedList}>
                {menuItems}
            </ul>
        </div>
        <MobileNav isOpen={interfaceStore.isMobileAccountMenuOpen}
                   toggleOpen={interfaceStore.toggleMobileAccountMenu}
                   identifier={accountIdentifier}
                   content={userMenuContent(userStore, i18nStore)}
        />
        <MobileNav isOpen={interfaceStore.isMobileNavMenuOpen}
                   toggleOpen={interfaceStore.toggleMobileNavMenu}
                   identifier={navigationIdentifier}
                   content={navigationContent(organizationStore)}
        />
    </ErrorBoundary>
})
